import { ChevronLeft, ChevronRight } from 'lucide-react';
import { MONTHS_DE } from './calendarHelpers';

interface MonthHeaderProps {
  cursor: Date;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
}

export function MonthHeader({ cursor, onPrev, onNext, onToday }: MonthHeaderProps) {
  return (
    <div className="mb-3 flex items-center justify-between">
      <h3 className="text-ink font-serif text-2xl font-normal tabular-nums">
        {MONTHS_DE[cursor.getUTCMonth()]} {cursor.getUTCFullYear()}
      </h3>
      <div className="flex items-center gap-1">
        <NavButton onClick={onPrev} aria-label="Vorheriger Monat">
          <ChevronLeft size={14} strokeWidth={2} />
        </NavButton>
        <button
          type="button"
          onClick={onToday}
          className="border-line/50 text-ink-soft hover:bg-paper/60 hover:text-ink rounded-md border px-3 py-1 text-[12px] font-medium transition-colors"
        >
          Heute
        </button>
        <NavButton onClick={onNext} aria-label="Nächster Monat">
          <ChevronRight size={14} strokeWidth={2} />
        </NavButton>
      </div>
    </div>
  );
}

function NavButton({ children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className="border-line/50 text-ink-soft hover:bg-paper/60 hover:text-ink grid size-7 place-items-center rounded-md border transition-colors"
    >
      {children}
    </button>
  );
}
